module.exports = __webpack_public_path__ + "img/assignment_turned_in.96a0fe62.svg";